import React from 'react';
import { Button } from '@/components/ui/button';
import { Download, FileText } from 'lucide-react';

export const DataSection = ({ exporting, onExportData }) => {
  return (
    <div className="bg-white/60 backdrop-blur-md border border-[#EAE4DC] shadow-lg rounded-2xl p-8">
      <div className="flex items-center space-x-3 mb-6">
        <FileText className="w-6 h-6 text-stone-600" strokeWidth={1.5} />
        <h2
          className="text-2xl font-medium"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Your Data
        </h2>
      </div>
      
      <p className="text-stone-600 mb-6">
        Export your journal entries, conversations, and progress data as a PDF.
      </p>
      
      <Button
        onClick={onExportData}
        disabled={exporting}
        variant="outline"
        className="rounded-full px-6"
        data-testid="export-data-button"
      >
        {exporting ? (
          'Exporting...'
        ) : (
          <>
            <Download className="w-4 h-4 mr-2" />
            Export My Data
          </>
        )}
      </Button>
    </div>
  );
};
